import GlobalApi from "../../Global";
import refresh_token from "../../Global/refresh_token";

const updateNotification = (companyId) => {
  return (dispatch) => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      user_id: data?.user_id,
      company_id: companyId,
    };

    // alert('token'+ token);

  

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Notification/get_all_notifications?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then((response) => {
        console.log("response from notifications+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++", response);
        if (response.status === "Success") {
          let unreads = [];
          if (response?.data.length == 0) {
            dispatch({
              type: "UPDATE_NOTIFICATION",
              counts: response?.data.length,
            });
          } else {
            response.data.map((item, index) => {
              if (!item.is_read) {
                unreads.push(item);
              }
            });
          }

          console.log("unreadsTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTTT",unreads)

          dispatch({
            type: "UPDATE_NOTIFICATION",
            counts: unreads.length,
          });
        }
      });
  };
};


  const clearNotification = () => {
    return {
        type: "CLEAR_NOTIFICATION"
    }
}

export { updateNotification , clearNotification };
